import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
    };

    return axios.get(`${url}/guidanceWorkplaces`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (id) {
    console.log(id);
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/guidanceWorkplaces/${id}?include=activities`, options)
        .then(response => {
            let guidanceWorkplace = jsona.deserialize(response.data);
            delete guidanceWorkplace.links;
            console.log(guidanceWorkplace);
            return guidanceWorkplace;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/guidanceWorkplaces/${id}?include=activities.exceptions,vessel,workplace,guidance`, options)
        .then(response => {
            let guidanceWorkplace = jsona.deserialize(response.data);
            delete guidanceWorkplace.links;
            return guidanceWorkplace;
        });
}

function add (guidanceWorkplace) {
    const payload = jsona.serialize({
        stuff: guidanceWorkplace,
        includeNames: ['activities','vessel','workplace','guidance']
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/guidanceWorkplaces?include=activities.activity,activities.exceptions,vessel,workplace,guidance`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (guidanceWorkplace) {
    const payload = jsona.serialize({
        stuff: guidanceWorkplace,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };
    // ?include=activities.activity,vessel,workplace,guidance
    return axios.patch(`${url}/guidanceWorkplaces/${guidanceWorkplace.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/guidanceWorkplaces/${id}`, options);
}

export default {
    list,
    get,
    show,
    add,
    update,
    destroy
};

